// extracted by mini-css-extract-plugin
module.exports = {"container":"SimulateTabTitle_container__2uPth"};